import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FormThemeEditor from './FormThemeEditor';

const FormThemeEditorBridge = react2angular(FormThemeEditor, [
  'formThemeId',
  'copy'
]);

export default FormThemeEditorBridge;
